module.exports = "<tt-global-notifications></tt-global-notifications>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 474
// module chunks = 0